export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12940.cbc74257.jpg";